// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__3c-p2"};